import type { HeartRiskInput } from "@/lib/heartRisk/types";

export interface HeartRiskValidationResult {
  valid: boolean;
  errors: string[];
}

export function validatePceInput(input: HeartRiskInput): HeartRiskValidationResult {
  const errors: string[] = [];

  if (input.age < 40 || input.age > 79) {
    errors.push("A idade deve estar entre 40 e 79 anos para o cálculo Pooled Cohort.");
  }

  if (input.systolicBp < 90 || input.systolicBp > 200) {
    errors.push("A pressão sistólica deve estar entre 90 e 200 mmHg.");
  }

  if (input.diastolicBp < 40 || input.diastolicBp > 140) {
    errors.push("A pressão diastólica deve estar entre 40 e 140 mmHg.");
  }

  if (input.totalCholesterol < 130 || input.totalCholesterol > 320) {
    errors.push("O colesterol total deve estar entre 130 e 320 mg/dL.");
  }

  if (input.hdlCholesterol < 20 || input.hdlCholesterol > 100) {
    errors.push("O HDL deve estar entre 20 e 100 mg/dL.");
  }

  if (input.hdlCholesterol >= input.totalCholesterol) {
    errors.push("O HDL deve ser menor que o colesterol total.");
  }

  return {
    valid: errors.length === 0,
    errors,
  };
}
